import { EncoderDecoder } from '@iotize/common/converter/api';
import {
  ApduResponse,
  TapRequestFrame,
  TapResponseFrame,
} from '@iotize/tap/client/api';

import { createApduFromTapRequest } from './apdu/tap-apdu-request-builder';
import { TapStreamReader, TapStreamWriter } from './frame/import-adapter';
import { TapClientError } from './tap-client-error';

export class TapApduRequestConverter
  implements EncoderDecoder<TapRequestFrame, Uint8Array>
{
  encode(tapRequest: TapRequestFrame) {
    try {
      const stream = new TapStreamWriter(5 + 1 + tapRequest.payload.length + 1);
      stream.writeApduRequest(createApduFromTapRequest(tapRequest));
      return stream.toBytes;
    } catch (err) {
      if (!(err instanceof TapClientError)) {
        throw TapClientError.cannotEncodeRequest(err as Error, tapRequest);
      } else {
        throw err;
      }
    }
  }

  decode(bufferData: Uint8Array | TapStreamReader) {
    const stream =
      bufferData instanceof TapStreamReader
        ? bufferData
        : TapStreamReader.create(bufferData);
    const apduHeader = stream.readApduRequestHeader();
    const tapRequestFrame = stream.readTapRequestFrame();
    return tapRequestFrame;
  }
}

export class TapApduResponseConverter
  implements EncoderDecoder<TapResponseFrame, Uint8Array>
{
  encode(tapResponseFrame: TapResponseFrame) {
    const stream = new TapStreamWriter();
    const tapRequestStream = new TapStreamWriter();
    tapRequestStream.writeTapResponseFrame(tapResponseFrame);
    stream.writeApduResponse({
      data: tapRequestStream.toBytes,
      status: ApduResponse.Status.OK,
    });
    return stream.toBytes;
  }

  decode(bufferData: Uint8Array | TapStreamReader): TapResponseFrame {
    try {
      const stream =
        bufferData instanceof TapStreamReader
          ? bufferData
          : TapStreamReader.create(bufferData);
      const apduResponse = stream.readApduResponse();

      if (apduResponse.status !== ApduResponse.Status.OK) {
        throw TapClientError.unexpectedApduStatusCode(apduResponse);
      }

      return TapStreamReader.fromArray(
        apduResponse.data,
      ).readTapResponseFrame();
    } catch (err) {
      if (!(err instanceof TapClientError)) {
        throw TapClientError.cannotDecodeResponseError(
          err as Error,
          bufferData instanceof TapStreamReader
            ? bufferData.toBytes
            : bufferData,
        );
      } else {
        throw err;
      }
    }
  }
}

export const TAP_REQUEST_FRAME_CONVERTER = new TapApduRequestConverter();
export const TAP_RESPONSE_FRAME_CONVERTER = new TapApduResponseConverter();
